import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';

import ShowDocumentListQuery from './ShowListDocument.graphql';
import RemoveDocumentList from './RemoveDocumentList.graphql';
import messages from '../../locale/messages';
import showToaster from '../../helpers/showToaster';
import { photosShow } from '../../helpers/photosShow';
import { documentuploadDir } from '../../config';
import { withMutation, withQuery } from '../../hoc/withGraphql';


import pdfIcon from '/public/SiteIcons/pdf_image.png';

import s from './DocumentList.css';

class DocumentList extends Component {

  static defaultProps = {
    data: {
      loading: true,
      showDocumentList: []
    },
  };

  constructor(props) {
    super(props);
  }

  handleClick = async (id, fileName) => {
    const { mutate } = this.props;

    const { data } = await mutate({
      RemoveDocumentList,
      variables: { id },
      refetchQueries: [{ query: ShowDocumentListQuery }]
    });


    if (data?.RemoveDocumentList?.status == "success") {
      const resp = await fetch('/deleteDocuments', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fileName }),
        credentials: 'include',
      });
      const { status } = await resp.json();
      showToaster({ messageId: 'removeDocList', toasterType: 'success' })
    }else{
      showToaster({ messageId: 'documentChangeWarning', toasterType: 'error' })
    }
  }

  render() {
    const { data: { ShowDocumentList }, data } = this.props;
    let path = photosShow(documentuploadDir);
    return (
      <>
        {ShowDocumentList && <div className={s.documentUploadListContainer}>
          {ShowDocumentList && ShowDocumentList?.map((item, key) => {
            let icon = item?.fileType == 'application/pdf' ? pdfIcon : (path + item?.fileName);
            return (
              <div key={key} className={s.documentUploadListItem}>
                <a href={path + item?.fileName} target="_blank">
                  <div className={s.documentUploadListImgContainer}>
                    <img className={s.documentUploadListImg} src={icon} />
                  </div>
                </a>
                <div className={s.documentUploadListRemoveBtnContainer}>
                  <div className={s.documentUploadListRemoveBtn} onClick={() => this.handleClick(item?.id, item?.fileName)}>
                    <FormattedMessage {...messages.removeFile} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>}
      </>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  withQuery(ShowDocumentListQuery, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
  withMutation(RemoveDocumentList, {
    options: {
      fetchPolicy: 'network-only'
    }
  }),
)(DocumentList);





